import { Seo } from "@/components/Seo";
import { Breadcrumbs, breadcrumbSchema } from "@/components/Breadcrumbs";

export const LegalLayout = ({ title, crumbLabel, path, description, children }) => {
  const crumbs = [{ label: crumbLabel }];
  return (
    <>
      <Seo title={`${title} | FRELONS50`} description={description} path={path} jsonLd={breadcrumbSchema(crumbs)} noindex />
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-8 md:py-12">
        <Breadcrumbs items={crumbs} />
        <h1 className="font-display text-3xl sm:text-4xl font-extrabold tracking-tight text-brand-black mt-6 mb-8">{title}</h1>
        <div className="prose-legal space-y-6 text-brand-text leading-relaxed">{children}</div>
      </div>
    </>
  );
};

export const LegalSection = ({ heading, children }) => (
  <section>
    <h2 className="font-display text-xl font-bold text-brand-black mb-2">{heading}</h2>
    <div className="space-y-2 text-brand-text">{children}</div>
  </section>
);

export const Todo = ({ children }) => (
  <span className="inline-block bg-brand-gold/15 text-brand-black font-semibold px-2 py-0.5 rounded">{children}</span>
);
